<script setup lang="ts">
import type { BagAllowance } from '@optionway/models';

const properties = defineProps<BagAllowance>();
</script>

<template>
  <component
    :is="usePascalCase(`SvgoResultsLuggage${properties.type}Bag`)"
    class="relative mr-2 text-xl @lg:mr-0"
    :class="(properties?.pieces ?? 0) === 0 ? 'text-gray-400' : 'text-text-green-700'"
    filled
  />
  <div
    class="absolute left-2.5 top-2.5 inline-flex w-4 flex-col items-center justify-center gap-2.5 rounded-lg border p-0.5"
    :class="(properties?.pieces ?? 0) === 0 ? 'border-gray-400 bg-gray-50' : 'border-green-200 bg-green-50'"
  >
    <div
      class="justify-start text-xs font-medium leading-3"
      :class="(properties?.pieces ?? 0) === 0 ? 'text-gray-400' : 'text-green-700'"
    >
      {{ properties?.pieces ?? 0 }}
    </div>
  </div>
</template>
